import React from "react";
import { Container } from "../Form/styled";

interface SimpleField {
  label?: string;
  content?: JSX.Element | JSX.Element[] | string | string[];
  hasBorder?: boolean;
  readonly?: boolean;
}

export const SimpleField: React.FC<SimpleField> = ({
  label,
  content,
  hasBorder,
  readonly,
}: SimpleField) => {
  return (
    <Container hasBorder={hasBorder} readonly={readonly}>
      {label && <h5>{label}</h5>}
      {content && <div>{content}</div>}
    </Container>
  );
};
